import createWebSocket from 'hooks/useBentoStream/utils/createWebSocket';

const SubscribableWebSocket = (
  getRoomAccess,
  subscribersRef,
  webSocketErrorHandler
) => {
  let _webSocket = null;

  const _onMessage = messageEvent => {
    const data = JSON.parse(messageEvent.data);
    const { channel } = data;

    if (!channel) {
      return;
    }

    Object.keys(subscribersRef.current).forEach(key => {
      const sub = subscribersRef.current[key];
      if (sub.channel === channel) {
        sub.callback(data);
      }
    });
  };

  const _onError = errorEvent => {
    webSocketErrorHandler(errorEvent);
  };

  const connect = async () => {
    _webSocket = await createWebSocket(getRoomAccess, _onMessage, _onError);
  };

  const subscribe = (channel, callback) => {
    const subscriberId = crypto.randomUUID();

    subscribersRef.current = {
      ...subscribersRef.current,
      [subscriberId]: {
        callback,
        channel
      }
    };

    return subscriberId;
  };

  const unsubscribe = id => {
    const newSubscribers = { ...subscribersRef.current };
    delete newSubscribers[id];

    subscribersRef.current = { ...newSubscribers };
  };

  const unsubscribeFromAll = () => {
    const subscriberIds = Object.keys(subscribersRef.current);
    subscriberIds.forEach(id => unsubscribe(id));
  };

  const disconnect = () => {
    unsubscribeFromAll();
    _webSocket.close();
    _webSocket = null;
  };

  return {
    connect,
    subscribe,
    unsubscribe,
    unsubscribeFromAll,
    disconnect
  };
};

export default SubscribableWebSocket;
